import * as React from 'react';
import { Ref, forwardRef } from 'react';
const SvgSolidChevronLeft = (_, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 16 16"
    height={_.height}
    width={_.width}
    className={_.className}
    role={_.role}
    aria-label={_.ariaLabel}
    aria-hidden={_.ariaHidden}
    ref={ref}
  >
    <path
      fill={_.color}
      fillRule="evenodd"
      d="M9.963 4.127 5.24 7.549a.542.542 0 0 0-.1.812q.045.05.1.09l4.723 3.422c.275.2.677.16.897-.09.09-.102.14-.23.14-.361V4.578c0-.32-.286-.578-.638-.578a.7.7 0 0 0-.4.127"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgSolidChevronLeft);
export default ForwardRef;
